import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Close as CloseIcon } from '@mui/icons-material';

import { ErrorCloseButton, ErrorDialog, ErrorInfoIcon, ErrorMessage, ErrorRetryButton, ErrorRow } from './Error.style';

type ErrorFallbackProps = {
  resetError: () => void;
};

export default function Error({ resetError }: ErrorFallbackProps) {
  const { t } = useTranslation();
  const [visible, setVisible] = useState(true);

  if (!visible) {
    return null;
  }

  return (
    <ErrorDialog>
      <ErrorRow direction="row" alignItems="center" spacing={1}>
        <ErrorInfoIcon />
        <ErrorMessage variant="body1">{t('error.dialog.unknownErrorMessage')}</ErrorMessage>
        <ErrorCloseButton aria-label="close" onClick={() => setVisible(false)}>
          <CloseIcon />
        </ErrorCloseButton>
      </ErrorRow>
      <ErrorRetryButton type="button" onClick={resetError}>
        {t('error.dialog.tryAgain')}
      </ErrorRetryButton>
    </ErrorDialog>
  );
}
